<template lang="pug">
  fpui-input-select.fpui-select-dynamic-parameters(
    v-model="model",
    :multiple='multiple',
    :options="options",
    :searchable='true'
    :clearable='clearable'
    :placeholder='placeholder'
  )
</template>

<script>
  export default {
    props: {
      value: { type: [Array, String] },
      filters: { type: Array },
      multiple: { type: Boolean, default: true },
      placeholder: { type: String },
      clearable: { type: Boolean, default: false },
      dynamicParameters: { type: Array, default () { return [] } }
    },
    computed: {
      model: {
        get () { return this.value },
        set (val) { this.$emit('input', val) }
      },
      options () {
        let options = this.dynamicParameters.map((dynP) => {
          return {
            value: dynP['dynamic-parameter'].id,
            label: dynP.label || dynP['dynamic-parameter'].id
          }
        })
        if (this.filters) {
          options = options.filter(option => this.filters.indexOf(option.value) !== -1)
        }
        return options
      }
    }
  }
</script>

<style lang="less">
</style>
